import React from "react";
import PropTypes from "prop-types";
import {Box} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {blinkAnimation} from "../../resources/styles/AnimationStyles";
import {useAgentFieldHighlightStyles} from "./formsStyles";

const AgentFieldHighlight = ({active, children}) => {
  const {classes} = useAgentFieldHighlightStyles();

  if (!active) {
    return children;
  }

  return (
    <Box className={classes.root}>
      <PlayArrowIcon className={classes.indicator} sx={blinkAnimation} fontSize="small" />
      {children}
    </Box>
  );
};

AgentFieldHighlight.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default AgentFieldHighlight;
